import { ClipboardList, PhoneCall, CalendarCheck2, HeartHandshake, ArrowRight } from 'lucide-react';
import { Reveal, Eyebrow } from './Reveal';
import { STEPS, scrollToId } from '../config/site';

const ICONS = {
  clipboard: ClipboardList,
  phone: PhoneCall,
  calendar: CalendarCheck2,
  heart: HeartHandshake,
};

export const HowItWorks = () => (
  <section id="how-it-works" className="ks-how scroll-mt-24 py-20 lg:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-2xl">
        <Eyebrow light>How It Works</Eyebrow>
        <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
          Four Simple Steps to a Fresher Home
        </h2>
        <p className="mt-5 text-base leading-relaxed text-white/80 sm:text-lg">
          No instant pricing, no automated booking — just personal service from your first message
          to your first clean.
        </p>
      </Reveal>

      <div className="relative mt-16">
        <svg
          viewBox="0 0 1200 40"
          preserveAspectRatio="none"
          className="absolute left-0 top-7 hidden h-10 w-full md:block"
          aria-hidden="true"
        >
          <path
            d="M60,20 C300,-10 500,50 620,18 C760,-10 980,45 1140,15"
            fill="none"
            stroke="#2DD4D9"
            strokeWidth="2.5"
            strokeDasharray="1 10"
            strokeLinecap="round"
          />
        </svg>

        <ol className="grid gap-12 md:grid-cols-4 md:gap-8">
          {STEPS.map((step, i) => {
            const Icon = ICONS[step.icon];
            return (
              <Reveal key={step.title} delay={i * 0.12}>
                <li className="relative h-full rounded-3xl border border-white/15 bg-white/10 p-6 shadow-soft" data-testid={`step-${i + 1}`}>
                  <div className="flex items-center gap-4">
                    <span className="pr-3 text-5xl font-extrabold tabular-nums leading-none text-aqua sm:text-6xl">
                      {String(i + 1).padStart(2, '0')}
                    </span>
                    <Icon size={26} className="text-aqua" strokeWidth={1.8} aria-hidden="true" />
                  </div>
                  <h3 className="mt-5 text-xl font-bold text-white">{step.title}</h3>
                  <p className="mt-2.5 max-w-[300px] text-base leading-relaxed text-white/80">
                    {step.description}
                  </p>
                </li>
              </Reveal>
            );
          })}
        </ol>
      </div>

      <Reveal className="mt-16">
        <button
          type="button"
          data-testid="how-it-works-quote-button"
          onClick={() => scrollToId('quote')}
          className="inline-flex items-center gap-2 rounded-full bg-aqua px-9 py-4 text-sm font-bold uppercase tracking-wide text-navy shadow-soft transition-all hover:-translate-y-0.5 hover:bg-white"
        >
          Get a Free Quote
          <ArrowRight size={16} />
        </button>
      </Reveal>
    </div>
  </section>
);

export default HowItWorks;
